import { useUser } from '@clerk/clerk-react'
import PublicGlobalHeader from './PublicGlobalHeader'
import { DASHBOARD_ACTION } from './PublicGlobalHeader'
import { buildStandingReturnPath, useOnboardingStanding } from '@/hooks/useOnboardingStanding'

interface GlobalHeaderProps {
  /** Logo-only header, for conversion landing pages. See PublicGlobalHeader. */
  minimal?: boolean
  /**
   * Which conversation this page's CTA is for. Defaults to the product demo;
   * /agency passes 'agency' so its header does not open the in-house buyer's
   * wizard on a page selling the partner program.
   */
  demoVariant?: 'product' | 'agency'
  /**
   * Where the demo request is recorded as coming from. Derived from the
   * variant unless a surface names its own, as the Astro header island does.
   */
  demoSource?: string
}

export default function GlobalHeader({ minimal = false, demoVariant = 'product', demoSource }: GlobalHeaderProps) {
  const { isSignedIn } = useUser()
  /* A HubSpot-path account waiting on its trial has no dashboard to go to;
     its one place is the report with the fix on it. */
  const { standing } = useOnboardingStanding()
  const accountAction = standing.pending
    ? { href: buildStandingReturnPath(standing), label: 'See your fix' }
    : DASHBOARD_ACTION

  return (
    <PublicGlobalHeader
      isSignedIn={isSignedIn}
      accountAction={accountAction}
      demoSource={demoSource ?? (demoVariant === 'agency' ? 'agency_header' : 'global_header')}
      demoVariant={demoVariant}
      minimal={minimal}
    />
  )
}
